import {
  SupplierRelationshipDiscountListResponseType,
  SupplierRelationshipProductItemDiscountListResponseType,
} from "@sellar-io/api-v2/types";

import { formatCurrency } from "@sellar-io/common";

import { createContext, useContext } from "react";

export type Connection = {
  id: number;
  buyerName: string;
  retailerId: number;
};

export type ItemDiscountType =
  SupplierRelationshipProductItemDiscountListResponseType[number];

export type ContainerDiscountType =
  SupplierRelationshipDiscountListResponseType[number];

export const ItemDiscountCardContext = createContext<
  | {
      editingItemDiscount?: ItemDiscountType;
      setEditingItemDiscount: (itemDiscount?: ItemDiscountType) => void;
      containerTypeDiscountList: ContainerDiscountType[];
      itemDiscountList: SupplierRelationshipProductItemDiscountListResponseType;
      connection: Connection;
    }
  | undefined
>(undefined);

export const useItemDiscountCardContext = () => {
  const context = useContext(ItemDiscountCardContext);
  if (context === undefined) {
    throw new Error(
      "useItemDiscountCardContext must be within ItemDiscountCardContextProvider",
    );
  }

  return context;
};

export const generateConnectionDiscountDescription = (
  connectionDiscount: SupplierRelationshipProductItemDiscountListResponseType[number],
) => {
  if (connectionDiscount.type === "percentage") {
    const discountAmount = connectionDiscount.discountAmount;
    return `${discountAmount}% off ${connectionDiscount.productName}`;
  }

  const discountAmount = formatCurrency(
    connectionDiscount.discountAmount,
    "GBP",
  );

  return `${discountAmount} off ${connectionDiscount.productName}`;
};
